import { CarouselTestimonios } from "../CarouselTestimonios";
import { MyButton } from "../MyButton";
import { useState, useEffect } from "react";
import phones2 from "../../../assets/img/banner/phones2.webp";

export function TrabajaConNosotros() {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [smallScreen, setSmallScreen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (screenWidth < 1000) {
      setSmallScreen(true);
    } else {
      setSmallScreen(false);
    }
  }, [screenWidth]);
  return (
    <div
      style={{
        backgroundImage: `url(${phones2})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        Height: "90rem",
        padding: "50px",
      }}
    >
      <div
        style={{ maxWidth: "85rem" }}
        className={`${
          smallScreen ? "flex-column" : "flex-row"
        }  d-flex justify-content-center align-items-center mx-auto `}
      >
        <div
          style={{
            width: smallScreen ? "100%" : "50%",
          }}
          className=" d-flex justify-content-center align-items-center mx-5"
        >
          <div
            className="p-3 d-flex justify-content-center align-items-start flex-column"
            style={{
              backgroundColor: "#2F2C57",
              borderRadius: "30px",
            }}
          >
            <h3 className="fs-1 mx-5 col-md-10 col-sm-12 title-info-home mb-4">
              Asesores expertos en marcas aliadas
            </h3>
            <p
              style={{ maxWidth: "35rem" }}
              className="text-start mx-5 paragraph-info-home mb-4"
            >
              ¿Eres un entusiasta de la tecnología móvil? Únete a nuestro equipo
              como asesor experto y comparte tu pasión ayudando a otros a elegir
              los mejores dispositivos.
            </p>
            <p className="mx-5 text-start">
              ¡Descubre una carrera emocionante con nosotros!
            </p>
            <div className="mx-5">
              <MyButton inverted color="purple" nombre="Conoce más" />
            </div>
          </div>
        </div>
        <div
          style={{ width: smallScreen ? "90%" : "50%" }}
          className="my-3 d-flex justify-content-center align-items-center"
        >
          <CarouselTestimonios />
        </div>
      </div>
    </div>
  );
}
